import { render, staticRenderFns } from "./inscription-change-status.vue?vue&type=template&id=33657747&scoped=true&"
import script from "./inscription-change-status.vue?vue&type=script&lang=js&"
export * from "./inscription-change-status.vue?vue&type=script&lang=js&"
import style0 from "./inscription-change-status.vue?vue&type=style&index=0&id=33657747&lang=scss&scoped=true&"
import style1 from "./inscription-change-status.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33657747",
  null
  
)

export default component.exports